export const PPSL_ADJUSTMENT_MODES = {
	COST_AND_QUANTITY: 'costAndQuantity',
	COST_ONLY: 'costOnly',
	QUANTITY_ONLY: 'quantityOnly',
};

// A field the adjustment mode hides is sent as zero, which the API reads as "no change".
export const getPpslAdjustmentPayload = (values: {
	adjustOnHandQuantity?: number;
	adjustTotalStockedPartsCost?: number;
	notes: string;
}) => ({
	...values,
	adjustOnHandQuantity: values.adjustOnHandQuantity || 0,
	adjustTotalStockedPartsCost: `${values.adjustTotalStockedPartsCost || 0}`,
});

// Mirrors the API: a quantity change with no cost change is valued at the current average cost,
// and a location left with no stock keeps no cost.
export const getPpslAdjustmentPreview = (
	onHandQuantity: number,
	totalStockedPartsCost: number,
	adjustOnHandQuantity: number,
	adjustTotalStockedPartsCost: number
) => {
	const averageCost = onHandQuantity > 0 ? totalStockedPartsCost / onHandQuantity : 0;
	const costChange =
		adjustTotalStockedPartsCost !== 0
			? adjustTotalStockedPartsCost
			: averageCost * adjustOnHandQuantity;
	const newOnHandQuantity = onHandQuantity + adjustOnHandQuantity;
	const newTotalStockedPartsCost = newOnHandQuantity > 0 ? totalStockedPartsCost + costChange : 0;
	return {
		onHandQuantity: newOnHandQuantity,
		totalStockedPartsCost: newTotalStockedPartsCost,
		weightedAvgCost: newOnHandQuantity > 0 ? newTotalStockedPartsCost / newOnHandQuantity : 0,
	};
};
